<div [innerHTML]="'shared:sidePanelDownloads.guides' | i18next"></div>

<mbs-input
  class="mt-3 d-block"
  [appendButtons]="[
    {
      type: 'secondary',
      icon: 'ico ico-Search'
    }
  ]"
  [clearButton]="true"
  [placeholder]="'shared:placeholders.searchRequest' | i18next"
  [formControl]="search"
  mbsAutoFocus>
</mbs-input>

@for (guide of filteredGuides(); track guide.link) {
  <mbs-tile
    [statusClass]="'bg-secondary'"
    [data]="null"
    [disabled]="false"
    [hoverAble]="false"
    [selectable]="false"
    [selected]="false"
    [showBody]="false"
    [class]="'mt-4'"
    [tileTemplate]="tileTemplate">
    <ng-template #tileTemplate>
      <div class="w-100 d-flex justify-content-between align-items-center py-2 px-3">
        <div class="overflow-hidden">
          <b class="text-sm">
            <mbs-text-ellipsis>{{ guide.title }}</mbs-text-ellipsis>
          </b>

          <div class="mt-1 text-xs text-gray">
            {{ guide.extension }}
          </div>
        </div>
        <div>
          <mbs-button
            [loading]="loadingFileLink() === guide.link"
            (click)="download(guide.link, guide.title)"
            type="secondary"
            [square]="true">
            <i class="ico ico-Download"></i>
          </mbs-button>
        </div>
      </div>
    </ng-template>
  </mbs-tile>
}
